module.exports = __webpack_public_path__ + "_assets/img/avatar_yunlin.325e8d76.jpg";